// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2519":"55185ff122306936","3548":"19f5a66f5432f35b","4794":"42774431f9d69244","7483":"e539b51a9d2d2f3d","8429":"54d285565127721c","9032":"3e2121174af05f29"}[chunkId] + ".js";
};